module.exports = __webpack_public_path__ + "img/@news_view_img.7dd2af1f.jpg";